module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/040-bhutan-202ed2b9a69c0d1dff5bcd092988c70e.svg";